import React, { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button'
function Sort({ sortOptions, onSortChange }) {
    // State to hold the selected item
    const [selectedItem, setSelectedItem] = useState(sortOptions[0].label);

    // Handle selection of an item
    const handleSelect = (eventKey) => {
        const selectedItem = sortOptions.find(option => option.value === eventKey)?.label || sortOptions[0].label;

        console.log(selectedItem);
        setSelectedItem(selectedItem); // Update the selected item
        onSortChange(eventKey);
    };

    return (
        <div>
            <div className='d-flex align-items-center'>
                <div className='text-4E4E4E text-12 fw-500 mr-10'>Sort by</div>
                <DropdownButton
                    id="dropdown-basic-button"
                    title={selectedItem}
                    onSelect={handleSelect}
                    className='sort-basic'
                >
                    {sortOptions.map((item) => (
                        <Dropdown.Item eventKey={item.value}>{item.label}</Dropdown.Item>
                    ))}
                </DropdownButton>
            </div>

        </div>
    );
}

export default Sort;
